import React from "react";
import { Box, Container, Typography } from "@mui/material";
import DeleteAccountSection from "../components/AccountDetailsComponents/DeleteAccountSection";
import { FONT_PRIMARY, FONT_WEIGHT } from "../theme/fonts";

export default function DeleteAccountPage() {
  return (
    <Box
      component="main"
      sx={{
        bgcolor: "var(--root-background, #f8f9fa)",
        py: { xs: 5, md: 8 },
        px: { xs: 2, md: 3 },
        minHeight: "60vh",
      }}
    >
      <Container maxWidth="sm">
        <Typography
          component="h1"
          sx={{
            fontFamily: FONT_PRIMARY,
            fontWeight: FONT_WEIGHT.extraBold,
            fontSize: { xs: 28, md: 34 },
            color: "#0f172a",
            mb: 1,
          }}
        >
          Delete your account
        </Typography>
        <Typography sx={{ fontSize: 15, color: "#334155", mb: 3, lineHeight: 1.6 }}>
          Permanently remove your CivixThread account and associated data. You will need to verify your
          identity before deletion completes.
        </Typography>
        <DeleteAccountSection standalone />
      </Container>
    </Box>
  );
}
